export const environment = {
  production: true,
  apiUrl: 'https://tstservicios-comprobantes.sistemasonline.com.ar/',
  apiUrlDev: 'http://localhost:3001/',
};
